// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loadingSpinner_jTe\\+pV3s{color:var(--color-gray-600);-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.loadingSpinner_jTe\\+pV3s i{margin:\"0 5px\";animation-duration:1s}.loadingSpinner_jTe\\+pV3s.lsSmall_FhtHTfxh{font-size:.8em}.loadingSpinner_jTe\\+pV3s.lsMedium_ylpf0rhg{font-size:1em}.loadingSpinner_jTe\\+pV3s.lsLarge_41Ewgf7W{font-size:1.2em}.loadingSpinner_jTe\\+pV3s.alignLeft_jT14S6WR{text-align:left}.loadingSpinner_jTe\\+pV3s.alignCenter_gDE31GhY{text-align:center}.loadingSpinner_jTe\\+pV3s.alignRight_ZItQbGG2{text-align:right}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loadingSpinner": "loadingSpinner_jTe+pV3s",
	"lsSmall": "lsSmall_FhtHTfxh",
	"lsMedium": "lsMedium_ylpf0rhg",
	"lsLarge": "lsLarge_41Ewgf7W",
	"alignLeft": "alignLeft_jT14S6WR",
	"alignCenter": "alignCenter_gDE31GhY",
	"alignRight": "alignRight_ZItQbGG2"
};
export default ___CSS_LOADER_EXPORT___;
